<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="档次">
                  <el-input  v-model="queryForm.gradeName"></el-input>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getWashServiceGradeList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addWashServiceGrade"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editWashServiceGrade(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteWashServiceGrade(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshWashServiceGradeList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="washServiceGradeList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="gradeName"
        label="档次"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="priceRatio"
        label="费用比例"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkWashServiceGrade(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editWashServiceGrade(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteWashServiceGrade(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="washServiceGradeStates[washServiceGradeState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="washServiceGrade"
          ref="washServiceGradeForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="档次"
            prop="gradeName"
          >
            <el-input
              size="small"
              v-model="washServiceGrade.gradeName"
              :disabled="washServiceGradeState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="费用比例"
            prop="priceRatio"
          >
            <el-input
              size="small"
              v-model="washServiceGrade.priceRatio"
              :disabled="washServiceGradeState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="washServiceGradeState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';

export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetWashServiceGradeList();
                    this.getWashServiceGradeList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetWashServiceGradeList();
                    this.getWashServiceGradeList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     gradeName: '', //档次
                     priceRatio: '', //费用比例
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                washServiceGradeState: 'add',
                washServiceGradeStates: {
                    add: '新建档次设置',
                    check: '查看档次设置',
                    edit: '修改档次设置'
                },

                multipleSelection: [],
                washServiceGradeList: [],
                washServiceGrade: {
                    id: '', //ID
                    gradeName: '', //档次
                    priceRatio: '', //费用比例
                    createTime: '', //创建时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    gradeName: [{ required: true, message: '档次不能为空', trigger: 'blur' }],
                    priceRatio: [{ required: true, message: '费用比例不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getWashServiceGradeList();
        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            resetWashServiceGradeList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.washServiceGradeList = [];
            },
            resetDialog() {
                this.washServiceGradeState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      gradeName: '', //档次
                      priceRatio: '', //费用比例
                };
                this.getWashServiceGradeList();
            },
            closeDialog() {
                this.showDialog = false
                this.washServiceGrade = {
                      id: '', //ID
                      gradeName: '', //档次
                      priceRatio: '', //费用比例
                      createTime: '', //创建时间
                };
            },
            submitForm() {
                if (this.washServiceGradeState == 'add') {
                    this.$refs.washServiceGradeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/servicegrade/add`,{ ...this.washServiceGrade }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetWashServiceGradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.washServiceGradeState == 'edit') {
                    this.$refs.washServiceGradeForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/wash/servicegrade/edit`,{ ...this.washServiceGrade }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetWashServiceGradeList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addWashServiceGrade() {
                this.showDialog = true;
                this.washServiceGradeState = 'add';
            },
            checkWashServiceGrade(washServiceGradeId) {
                console.log(washServiceGradeId);
                this.currentWashServiceGradeId = washServiceGradeId;

                this.getWashServiceGradeById();
                this.showDialog = true;
                this.washServiceGradeState = 'check';
            },
            editWashServiceGrade(washServiceGradeId) {
                console.log('washServiceGrade', washServiceGradeId);
                if (washServiceGradeId) {
                    this.currentWashServiceGradeId = washServiceGradeId;
                    this.getWashServiceGradeById();
                } else {
                    this.washServiceGrade = { ...this.washServiceGrade, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.washServiceGradeState = 'edit';
            },
            deleteWashServiceGrade(washServiceGradeId) {
                let ids = '';
                if (washServiceGradeId) {
                    ids = washServiceGradeId;
                } else {
                    ids = this.multipleSelection.map((washServiceGrade) => washServiceGrade.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/wash/servicegrade/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetWashServiceGradeList();
                                this.getWashServiceGradeList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshWashServiceGradeList() {
                this.resetWashServiceGradeList();
                this.getWashServiceGradeList();
            },
            getWashServiceGradeList(query = {}) {
                this.loading = true;
                get(`/wash/servicegrade/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.washServiceGradeList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getWashServiceGradeById() {
                get(`/wash/servicegrade/get`,{ id: this.currentWashServiceGradeId }).then((res) =>{
                    if(res.success){
                      this.washServiceGrade = { ...this.washServiceGrade, ...res.washServiceGrade };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportWashServiceGradeList() {
                //this.btnLoading = true;
                exprotExcel(`/wash/servicegrade/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/wash/servicegrade/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/wash/servicegrade/importData`,formData);
              this.refreshWashServiceGradeList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getWashServiceGradeList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getWashServiceGradeList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>